import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { motion } from 'framer-motion';

const Divider = ({ text = 'or' }) => {
  return (
    <motion.div
      className={css(styles.dividerContainer)}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className={css(styles.dividerLine)}
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      />
      <motion.span
        className={css(styles.dividerText)}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        {text}
      </motion.span>
      <motion.div
        className={css(styles.dividerLine)}
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      />
    </motion.div>
  );
};

const styles = StyleSheet.create({
  dividerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    margin: '1rem 0'
  },
  dividerLine: {
    flex: 1,
    height: '1px',
    backgroundColor: '#e2e8f0',
    transformOrigin: 'center'
  },
  dividerText: {
    padding: '0 1rem',
    color: '#718096',
    fontSize: '0.875rem',
    fontWeight: '500',
    textTransform: 'uppercase'
  }
});

export default Divider;
